export var SHOW = '@redux-modal/SHOW';
export var HIDE = '@redux-modal/HIDE';
export var DESTROY = '@redux-modal/DESTROY';



//////////////////
// WEBPACK FOOTER
// ./~/redux-modal/es/actionTypes.js
// module id = 15
// module chunks = 0